(function () {
  'use strict';

  function byId(id) { return document.getElementById(id); }

  /* ===== EVENT DELEGATION ===== */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var faqBtn = t.closest ? t.closest('.faq-btn') : null;
    if (faqBtn) {
      var item = faqBtn.parentElement;
      var wasOpen = item.classList.contains('open');
      var all = document.querySelectorAll('.faq-item.open');
      for (var i = 0; i < all.length; i++) { all[i].classList.remove('open'); }
      if (!wasOpen) { item.classList.add('open'); }
      return;
    }

  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      var info = e.target.closest ? e.target.closest('.infographic-wrap') : null;
      if (info) { e.preventDefault(); openLightbox(info); return; }
    }
    if (e.key === 'Escape') {
      var modal = byId('supp-modal');
      if (modal && modal.classList.contains('open')) { modal.classList.remove('open'); }
      var lb = byId('lightbox');
      if (lb && lb.classList.contains('open')) { lb.classList.remove('open'); }
    }
  });

  /* ===== NAMED CONTROLS ===== */
  function on(id, fn) { var el = byId(id); if (el) { el.addEventListener('click', fn); } }

  /* Video swap-in */
  on('video-play-btn', function () {
    var area = byId('video-area');
    if (!area) return;
    var v = document.createElement('video');
    v.className = 'video-player';
    v.src = 'https://cdn.shopify.com/videos/c/o/v/f559ebb7d8404476a9825c1ebdcbc75c.mp4';
    v.controls = true; v.autoplay = true; v.playsInline = true;
    area.innerHTML = '';
    area.appendChild(v);
  });

  /* Supplement facts modal */
  on('open-facts-btn', function () { var m = byId('supp-modal'); if (m) { m.classList.add('open'); lockScroll(true); } });
  on('close-facts-btn', function () { var m = byId('supp-modal'); if (m) { m.classList.remove('open'); lockScroll(false); } });
  var suppModal = byId('supp-modal');
  if (suppModal) {
    suppModal.addEventListener('click', function (e) { if (e.target === suppModal) { suppModal.classList.remove('open'); lockScroll(false); } });
  }

  /* Shared lightbox for infographics */
  function lockScroll(on) { document.body.style.overflow = on ? 'hidden' : ''; }
  function closeLightbox() { var lb = byId('lightbox'); if (lb) { lb.classList.remove('open'); lockScroll(false); } }
  function openLightbox(wrap) {
    var lb = byId('lightbox');
    var img = byId('lightbox-img');
    if (!lb || !img) return;
    img.src = wrap.getAttribute('data-src');
    var inner = wrap.querySelector('img');
    img.alt = inner ? inner.alt : '';
    lb.classList.add('open');
    lb.scrollTop = 0; lb.scrollLeft = 0;
    lockScroll(true);
  }
  var infographics = document.querySelectorAll('.infographic-wrap');
  for (var gi = 0; gi < infographics.length; gi++) {
    (function (wrap) {
      wrap.addEventListener('click', function () { openLightbox(wrap); });
      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(wrap); }
      });
    })(infographics[gi]);
  }
  var lightbox = byId('lightbox');
  if (lightbox) {
    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) { closeLightbox(); } });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeLightbox();
    var m = byId('supp-modal');
    if (m && m.classList.contains('open')) { m.classList.remove('open'); lockScroll(false); }
  });
  on('lightbox-close-btn', function () { closeLightbox(); });

  /* ===== STICKY BAR VISIBILITY: show after scrolling past the hero, hide near footer ===== */
  var stickyBar = byId('sticky-bar');
  var offerEl = byId('offer');
  var footerEl = byId('nhd-optilipid-footer');
  function updateStickyBar() {
    if (!stickyBar || !offerEl) return;
    var offerRect = offerEl.getBoundingClientRect();
    var pastOffer = offerRect.bottom < 0;
    var nearFooter = false;
    if (footerEl) {
      var fRect = footerEl.getBoundingClientRect();
      nearFooter = fRect.top < window.innerHeight;
    }
    if (pastOffer && !nearFooter) { stickyBar.classList.add('visible'); }
    else { stickyBar.classList.remove('visible'); }
  }

  /* ===== BACK TO TOP: show past ~85% of page ===== */
  var backTop = byId('back-top');
  function updateBackTop() {
    if (!backTop) return;
    var docH = document.documentElement.scrollHeight;
    var vh = window.innerHeight;
    var threshold = 0.85 * (docH - vh);
    if (window.scrollY > threshold && threshold > 0) { backTop.classList.add('visible'); }
    else { backTop.classList.remove('visible'); }
  }
  if (backTop) {
    backTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  window.addEventListener('scroll', function () { updateStickyBar(); updateBackTop(); }, { passive: true });

  /* ===== PRICING SECTION TOGGLE (One-Time / Subscribe) ===== */
  function nhdSetPricingMode(mode) {
    var grid = byId('pricing-cards');
    if (grid) { grid.setAttribute('data-mode', mode); }
    var toggle = byId('pricing-toggle');
    if (toggle) {
      var btns = toggle.querySelectorAll('.pt-btn');
      for (var i = 0; i < btns.length; i++) {
        var active = btns[i].getAttribute('data-mode') === mode;
        btns[i].setAttribute('data-active', active ? 'true' : 'false');
        btns[i].setAttribute('aria-checked', active ? 'true' : 'false');
      }
    }
  }

  var pricingToggle = byId('pricing-toggle');
  if (pricingToggle) {
    pricingToggle.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.pt-btn') : null;
      if (!btn) return;
      nhdSetPricingMode(btn.getAttribute('data-mode'));
    });
  }

  /* Jump links elsewhere on the page that should open the pricing section
     already set to the matching One-Time or Subscribe view. */
  function nhdWireJumpToPricing(id, mode) {
    on(id, function () {
      nhdSetPricingMode(mode);
      var pricing = byId('pricing');
      if (pricing) { pricing.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  }
  nhdWireJumpToPricing('consistency-sub-btn', 'subscribe');
  nhdWireJumpToPricing('consistency-one-time-link', 'onetime');
  nhdWireJumpToPricing('membership-sub-btn', 'subscribe');
  nhdWireJumpToPricing('one-time-final-link', 'onetime');

  /* ===== QUANTITY SELECTOR CAP ===== */
  /* Theme's native +/- buttons have no built-in max. This clamps the
     retail quantity field to NHD_QTY_MAX without touching theme.js. */
  var NHD_QTY_MAX = 3;

  function nhdClampQtyInput(input) {
    if (!input) { return; }
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 1) { v = 1; }
    if (v > NHD_QTY_MAX) { v = NHD_QTY_MAX; }
    if (String(v) !== input.value) {
      input.value = String(v);
      input.setAttribute('value', String(v));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return v;
  }

  function nhdUpdateQtyButtons(root) {
    var input = root.querySelector ? root.querySelector('.QuantitySelector__CurrentQuantity') : null;
    if (!input) { return; }
    var v = nhdClampQtyInput(input);
    var inc = root.querySelector('[data-action="increase-quantity"]');
    if (inc) {
      var atMax = v >= NHD_QTY_MAX;
      inc.disabled = atMax;
      inc.setAttribute('aria-disabled', atMax ? 'true' : 'false');
      inc.style.opacity = atMax ? '.4' : '';
      inc.style.cursor = atMax ? 'not-allowed' : '';
    }
  }

  document.addEventListener('click', function (e) {
    var selector = e.target.closest ? e.target.closest('.QuantitySelector') : null;
    if (!selector) { return; }
    var isQtyBtn = e.target.closest('[data-action="increase-quantity"], [data-action="decrease-quantity"]');
    if (!isQtyBtn) { return; }
    setTimeout(function () { nhdUpdateQtyButtons(selector); }, 0);
  }, true);

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('QuantitySelector__CurrentQuantity')) {
      var selector = e.target.closest('.QuantitySelector');
      if (selector) { nhdUpdateQtyButtons(selector); }
    }
  });

  document.querySelectorAll('.QuantitySelector').forEach(function (sel) { nhdUpdateQtyButtons(sel); });

  /* ===== INIT ===== */
  var yr = byId('yr');
  if (yr) { yr.textContent = String(new Date().getFullYear()); }
  updateStickyBar();
  updateBackTop();
})();
